export default __webpack_public_path__ + "static/media/promo-banner-explore.6bd0d8e8.svg";